import { currentOrgId } from './orgContext.js';

export function buildCodelyLaunchUrl(activityUrl) {
  const rawActivityUrl = String(activityUrl || '').trim();
  if (!rawActivityUrl) {
    throw new Error('Activity link is required.');
  }

  let parsedActivityUrl;
  try {
    parsedActivityUrl = new URL(rawActivityUrl);
  } catch {
    throw new Error('Activity link is not a valid URL.');
  }

  if (!['http:', 'https:'].includes(parsedActivityUrl.protocol)) {
    throw new Error('Activity link must be an HTTP or HTTPS URL.');
  }

  const target = new URL('launch.html', window.location.href);
  const orgId = currentOrgId();
  if (orgId) {
    target.searchParams.set('orgId', orgId);
  }
  target.searchParams.set('activityUrl', parsedActivityUrl.toString());
  target.searchParams.set('embed', '1');
  return `${target.pathname}${target.search}${target.hash}`;
}
